export const getUserColor = (userColor: string) => {
  let color: string;
  if (userColor) {
    color = userColor;
  } else {
    color = "white";
  }
  return `bg-${color}`;
};
